import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ModalCopiaSeguridadProgramada from '../../components/copiaSeguridad/ModalCopiaSeguridadProgramada'
import {cerrarModalCopiaSeguridadProgramada, obtenerProgramacionCopiaSeguridad, submitNuevaCopiaSeguridadProgramada} from '../../actions/copiaSeguridad/copiaSeguridad'

export function mapStateToProps (state) {
  return {
    ...state.copiaSeguridad,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      cerrarModalCopiaSeguridadProgramada,
      obtenerProgramacionCopiaSeguridad,
      submitNuevaCopiaSeguridadProgramada
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalCopiaSeguridadProgramada))